"use client";

import { use } from "react";
import { AuthProvider } from "@/lib/auth-context";
import { AppContent } from "../page";

export default function ManualDynamicPage({ params }: { params: Promise<{ id: string }> }) {
  // ב-Next.js החדש (15+), params הוא Promise שיש לעשות לו unwrap
  const resolvedParams = use(params);
  const id = resolvedParams.id;

  return (
    <AuthProvider>
      <AppContent id={id} />
    </AuthProvider>
  );
}